import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["maxLength", "onChange", "value"];
import React from 'react';
import classNames from 'classnames';
import { Textarea } from './Textarea';
import styles from './LimitedTextarea.module.less';
export var LimitedTextarea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _value$length;

  var _props$maxLength = props.maxLength,
      maxLength = _props$maxLength === void 0 ? 5000 : _props$maxLength,
      onChange = props.onChange,
      value = props.value,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      count = _React$useState2[0],
      setCount = _React$useState2[1];

  var handleChange = function handleChange(e) {
    var newValue = e.target.value;

    if (newValue.length > maxLength) {
      return;
    }

    setCount(newValue.length);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Textarea, _extends({}, otherProps, {
    maxLength: maxLength,
    value: value,
    onChange: handleChange // Textarea must be full width to account for float right char count
    // layout.
    ,
    fullWidth: true,
    ref: ref
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['limit-count'], _defineProperty({}, styles['limit-count-warning'], maxLength - count <= 10))
  }, maxLength - count));
});